module.exports = __webpack_public_path__ + "img/mediator-diplomat.a4f2de8c.svg";